import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { PhdsoftCommonService } from '@phdsoft/common';
@Injectable({
  providedIn: 'root'
})
export class AppService implements OnDestroy {
  private _IS_ONLINE: boolean = true;
  get isOnline(): boolean {
    return this._IS_ONLINE;
  }
  set isOnline(value: boolean) {
    this._IS_ONLINE = value;
  }

  private $connectionSubscribe: Subscription;
  isNetworkStopped = false;

  constructor(
    private connectionService: ConnectionService,
    private phdsoftCommonService: PhdsoftCommonService,
  ) {
    this._IS_ONLINE = window.navigator.onLine;

    // Trigger offline sync when going online
    fromEvent(window, 'online').subscribe(e => {
      this._IS_ONLINE = true;
      console.log('🔌 online');
      this.phdsoftCommonService.runBackground(this.phdsoftCommonService.offlineSync());
    });

    fromEvent(window, 'offline').subscribe(e => {
      this._IS_ONLINE = false;
      console.log('offline');
    });

    // Trigger offline sync on application reload/startup
    if (window.navigator.onLine) {
      console.log('🔌 Application started online - triggering offline sync');
      this.phdsoftCommonService.runBackground(this.phdsoftCommonService.offlineSync());
    }
  }

  start(): void {
    this.$connectionSubscribe = this.connectionService.monitor().subscribe((connectionState: ConnectionState) => {
      this._IS_ONLINE = connectionState.hasInternetAccess || window.navigator.onLine;
    });
  }

  ngOnDestroy(): void {
    if (this.$connectionSubscribe && !this.$connectionSubscribe.closed) {
      this.$connectionSubscribe.unsubscribe();
    }
  }
}
